<template>
  <b-card no-body class="mb-2">
    <b-card-header>
      <b-row align-v="center">
        <b-col cols="auto" class="mr-auto">
          <h5 class="">Расходы</h5>
        </b-col>
        <b-col cols="auto">
          <b-button size="sm" variant="success" @click.stop="onAddCost()" :disabled="isDisabled || !canLocationEditFinance()">
            <font-awesome-icon icon="plus" class="mr-1"/>
            Добавить
          </b-button>
        </b-col>
      </b-row>
    </b-card-header>

    <b-table
      id="location-costs"
      ref="location_costs"
      class="mb-0"
      striped
      small
      thead-class="top-fixed-thead thead-light"
      table-class="text-small"
      responsive
      show-empty
      :empty-text="$t('message.common.emptyTable')"
      :busy="isBusy"
      :items="items"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-compare="sortPeriodCompare"
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
    >
      <template #table-busy>
        <div class="text-center text-success my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Загрузка</strong>
        </div>
      </template>

      <template #cell(cost_type)="row">
        <location-cost-type-select
          id="location-cost-type-select"
          ref="location_cost_type_select"
          :is-disabled = "isDisabled"
          v-on:onSelect="onSelectLocationCostType($event, row)"
          v-bind:id = row.item.cost_type
        />
      </template>

      <template #cell(period)="row">
        <div style="display: flex;align-items: center;justify-content: left;">
          <b-form-input
            id="input_start_date"
            size="sm"
            class="widthDate"
            :disabled="isDisabled"
            type="date"
            v-model.date="row.item.start_date"/>
          <div class="mx-1">-</div>
          <b-form-input
            id="input_end_date"
            size="sm"
            class="widthDate"
            :disabled="isDisabled"
            type="date"
            v-model.date="row.item.end_date"/>
        </div>
      </template>

      <template #cell(sum)="row">
        <b-form-input
          id="input_sum"
          size="sm"
          class="widthPrice"
          :disabled="isDisabled"
          autocomplete="off"
          v-model.number="row.item.sum">
        </b-form-input>
      </template>

      <template #cell(comment)="row">
        <b-form-input
          id="input_comment"
          size="sm"
          :disabled="isDisabled"
          autocomplete="off"
          v-model="row.item.comment">
        </b-form-input>
      </template>

      <template #cell(action)="row">
        <b-button size="sm" variant="danger" @click="onRemoveCost(row)" :disabled="isDisabled">
          <font-awesome-icon icon="trash" />
        </b-button>
      </template>
    </b-table>

    <b-card-footer footer-bg-variant="light">
      <b-row align-h="between" align-v="center">
        <b-col cols="auto" class="mr-auto">
          Всего записей: <b>{{items.length}}</b>
        </b-col>
        <b-col cols="auto">
          <b-pagination
            id="location-costs-pagination"
            pills
            :total-rows="items.length"
            :per-page="perPage"
            v-model="currentPage"/>
        </b-col>
      </b-row>
    </b-card-footer>
  </b-card>
</template>

<script>
import locations from "../../network/locations";
  import dateFormatter from "../../utilites/dateFormatter";
  import helpers from "../../utilites/helpers";
  import permissions, {PERM} from "../../utilites/permissions";
    import LocationCostTypeSelect from "../Catalogs/LocationCostTypes/LocationCostTypeSelect";

export default {
  name: "LocationCosts",
  components: { LocationCostTypeSelect },
  mixins: [
    locations,
    dateFormatter, helpers, permissions
  ],
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      locationId: 0,
      isBusy: false,
      items: [],
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          key: 'cost_type',
          label: 'Тип расхода',
          class: 'widthCostType',
          sortable: false,
        },
        {
          key: 'period',
          label: 'Период',
          class: 'widthPrice',
          sortable: true,
        },
        {
          key: 'sum',
          label: 'Сумма',
          class: 'widthPrice',
          sortable: false,
        },
        {
          key: 'comment',
          label: 'Комментарий',
          sortable: false,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'widthPrice',
          tdClass: 'align-bottom',
          sortable: false,
        },
      ],
      sortBy: 'period',
      sortDesc: true,
    }
  },
  methods: {
    configure(locationId) {
      this.locationId = locationId;
      this.getCosts();
    },
    async getCosts() {
      this.isBusy = true;
      const result = await this.getLocationCostsById(this.locationId);
      this.isBusy = false;

      if (result.data == null) { return; }

      let costs = result.data.items;
      costs.forEach(function (cost) {
        cost.start_date = this.formatDate(this.getDateFromServerString(cost.start_date));
        cost.end_date = this.formatDate(this.getDateFromServerString(cost.end_date));
      }.bind(this));

      this.items = costs;
    },
    onAddCost() {
      const cost = {
        id: 0,
        cost_type: 0,
        start_date: this.formatDate(new Date()),
        end_date: this.formatDate(new Date()),
        sum: null,
        comment: ''
      };
      this.items.unshift(cost);
      this.setTableOrder();
    },
    onRemoveCost(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление расходов";
      const message = "Вы уверены, что хотите удалить эти расходы?";
      this.showModalDelete(title, message, function () {
        const index = this.items.findIndex(item => item === row.item);
        this.items.splice(index, 1);
      }.bind(this));
    },
    async saveCosts(locationId) {
      let costs = this.items;

      costs.forEach(function (cost) {
        cost.start_date = this.localISOString(this.getDateToServer(cost.start_date));
        cost.end_date = this.localISOString(this.getDateToServer(cost.end_date));
      }.bind(this));

      return await this.postLocationCosts(costs, locationId);
    },
    onSelectLocationCostType(costType, row) {
      if (costType != null) {
        row.item.cost_type = costType.id;
      } else {
        row.item.cost_type = 0;
      }
    },
    setTableOrder() {
      this.sortBy = 'period';
      this.sortDesc = true;
      this.currentPage = 1;
    },
    canLocationEditFinance() {
      return this.hasPermission([PERM.LOCATION_EDIT_FINANCE]);
    },
  }
}
</script>

<style>
.widthPrice {
  width: 120px;
}

.widthCatalog {
  width: 200px;
}

.widthPeriod {
  width: 270px;
}

.widthDate {
  width: 125px;
}

.widthCostType {
  min-width: 200px;
}

#location-costs td {
  text-align: center;
}

#location-costs th {
  text-align: center;
  vertical-align: middle;
}

#location-costs-pagination {
  margin-bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationCosts.vue